import { InvoicingCutoffClassEnum } from 'src/app/enum/invoicing-cutoff-class-enum';
import { InvoicingCutoffEnums } from 'src/app/enum/invoicing-cutoff-enums';
export class InvoicingCutoffModel {
  invoicingCutoffId: number = 0;
  branchId: number = 0;
  consecutive: number = 0;
  enterpriseId: number = 0;
  dateCutoff: Date = new Date;
  invoicingCutoffTypeId: number = InvoicingCutoffEnums.tipoCompleto;
  invoicingCutoffStateId: number = InvoicingCutoffEnums.estadoAbierto;
  preInvoicingStateId: number | null = null;
  observation: string | null = null;
  userIdBlock: number | null = null;
  invoicingCutoffClass: number = InvoicingCutoffClassEnum.expiredInvoice;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
